'use client'

import { useEffect, useRef } from 'react'
import { PopoverInitializer } from '../../utils'
import { getProductLabels } from '@dustin-web/product-components/src/cards/utils'
import { ProductDigitalData } from '@dustin-web/product-components/src/utils/product-digital-data'
import { useI18n } from '@dustin-web/microsite-components/src/i18n/use-i18n'
import { ProductPageType } from '..'

export default function Tracking({
  product,
  children,
}: {
  product: ProductPageType
  children: React.ReactNode
}) {
  const { translate } = useI18n()
  const isAvailableForSale = product?.availability?.isAvailableForSale
  const IsNotifyEligible = product?.availability?.IsNotifyEligible
  const origin = IsNotifyEligible
    ? 'notifyMeProductPage'
    : !isAvailableForSale
      ? 'eolProductPage'
      : 'productPage'

  const prevProductIdRef = useRef<string | null>(null)

  useEffect(() => {
    PopoverInitializer.init()

    if (product && product.id !== prevProductIdRef.current) {
      ProductDigitalData.pushViewItem(
        {
          ...product,
          label: getProductLabels(product),
        },
        translate,
        origin
      )

      prevProductIdRef.current = product.id
    }
  }, [origin, product, translate])

  return <>{children}</>
}
